import { getFacets } from "@components/AlgoliaCustomComponents";
import getTranslation from "@components/RecipeGrid/util/getTranslation";
import { useQueryStringStorage } from "@hooks/useQueryStringStorage/useQueryStringStorage";
import { useLocale } from "@jmc/core/src/hooks/useLocale/index";
import { Tag } from "@jmc/solid-design-system/src/components/atoms/Tag/Tag";
import { Typography } from "@jmc/solid-design-system/src/components/atoms/Typography/Typography";
import { useJnjBranding } from "@jmc/utils/hooks/useJnjBranding";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import style from "../style.module.scss";

export const TagList = (props: {
    tags: string[];
    recipeLiterals: {
        title: string;
        translation: string;
    }[];
    locationState: {
        anchor?: string;
        origin?: string;
        hashKey?: string;
    };
    haveOrigin?: boolean;
    haveHashKey?: boolean;
    serviceEnabled?: boolean;
    serviceUrl?: string;
}): JSX.Element => {
    const { jnjFullBranded } = useJnjBranding();
    const { t } = useTranslation();
    const locale = useLocale();
    const qss = useQueryStringStorage();

    const {
        tags,
        recipeLiterals,
        haveOrigin = false,
        haveHashKey = false,
        serviceEnabled = false,
        serviceUrl,
        locationState,
    } = props;
    const [facets, setFacets] = useState(null);

    useEffect(() => {
        getFacets().then((f) => setFacets(f));
    }, []);

    const getRecipeLiteralKey = (tagText: string): string => {
        const literalKey = recipeLiterals?.find((literal) => literal?.translation === tagText)?.title || tagText;
        return literalKey;
    };

    const getCategoryForRefinement = (refinementOption: string): string => {
        let category = "";

        const facetCategories = Object.keys(facets);
        facetCategories.some((cat) => {
            if (typeof facets[cat][refinementOption] !== "undefined") {
                category = cat;
                return true;
            }
            return false;
        });

        return category;
    };

    return (
        <div className={style.specialties}>
            {jnjFullBranded && (
                <Typography variant="h2" color="dark" size={"xl"} font="title">
                    {t("Categories", { ns: "recipe" })}
                </Typography>
            )}
            {tags?.map((tag, index: number) => {
                if (tag !== null) {
                    return (
                        <Tag
                            key={index}
                            color="default"
                            enableHover={haveOrigin || serviceEnabled ? true : false}
                            dismissable={false}
                            onClick={(e) => {
                                const url =
                                    haveOrigin && haveHashKey
                                        ? new URL(locationState?.origin)
                                        : new URL(`${locale}${serviceUrl}`, process.env.GATSBY_APP_DOMAIN);
                                const tagContent = getRecipeLiteralKey(e.currentTarget.textContent);
                                const category = getCategoryForRefinement(tagContent);
                                url.searchParams.append(`${category}[0]`, tagContent);
                                qss.clearItems(locationState?.hashKey);
                                qss.storeItem(locationState?.hashKey, `${category}[0]`, tagContent);
                                window.location.href = url.toString();
                            }}
                        >
                            <Typography key={index} size="xs">
                                {getTranslation(tag, t)}
                            </Typography>
                        </Tag>
                    );
                }
            })}
        </div>
    );
};
